import { QUERY_RESPONSE_RECEIVED } from '@web-platform/shared-universal-constants/src/network';
import {
  MICHELIN_GET_HOTEL_CARHIRE_CREATE_SEARCH,
  MICHELIN_GET_HOTEL_CARHIRE_POLLING,
} from '@web-platform/shared-universal-types/src/network/requestTypes';

import type { SkyscannerMichelinSearchV1Search } from '@skyscanner-internal/michelin-web-http-client';
import type { Action } from '@web-platform/shared-universal-types/src/redux/banana/actions/actions-banana-types';
import type { CarHireIndicativePricingState } from '@web-platform/shared-universal-types/src/redux/banana/state/shared/michelin/carHireIndicativePricing';

type SearchResponse = SkyscannerMichelinSearchV1Search.SearchResponse;

export const INITIAL_STATE: CarHireIndicativePricingState = {};

const transformCarHireIndicativePricingData = (
  response: SearchResponse,
  state: CarHireIndicativePricingState = INITIAL_STATE,
): CarHireIndicativePricingState => {
  const carHireIndicativePricesSection = response.sections?.find(
    (section) => section?.carhireIndicativePrices,
  );

  if (!carHireIndicativePricesSection?.carhireIndicativePrices) {
    return state;
  }

  return carHireIndicativePricesSection.carhireIndicativePrices;
};

export default (
  state: CarHireIndicativePricingState = INITIAL_STATE,
  action: Action,
): CarHireIndicativePricingState => {
  switch (action.type) {
    case QUERY_RESPONSE_RECEIVED: {
      const { response, type } = action.payload;

      if (
        (type === MICHELIN_GET_HOTEL_CARHIRE_CREATE_SEARCH ||
          type === MICHELIN_GET_HOTEL_CARHIRE_POLLING) &&
        response?.body &&
        typeof response.body === 'object' &&
        'sections' in response.body
      ) {
        return transformCarHireIndicativePricingData(response.body, state);
      }

      return state;
    }
    default:
      return state;
  }
};

export const get = (state: CarHireIndicativePricingState): CarHireIndicativePricingState => state;
